import '@/plugins/axios'
import { getBaseUrl, getParameter } from '@/utils/endpoint'

export function autoComplete(data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.post(getBaseUrl() + '/maps/placeautocomplete', data, { params: new_params })
}

export function placeDetail(id, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.get(getBaseUrl() + '/maps/placedetails/' + id, { params: new_params })
}

export function geoCodeByLatLng(data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.post(getBaseUrl() + '/maps/geocodebylatlon', data, { params: new_params })
}

export function distanceMatrix(data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.post(getBaseUrl() + '/maps/distancematrix', data, { params: new_params })
}
